module.exports = __webpack_public_path__ + "img/10.fe16d4a3.png";